module.exports = __webpack_public_path__ + "static/media/head.772c0412.svg";